import {ChangeDetectorRef, Component, EventEmitter, inject, Input, Output} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  BaseComponent, LiveWidgetsFieldsListComponent, SearchComponent,
  SecurityComponent, WmsCriteriaBuilderComponent,
  WmsDialogBodyComponent, WmsDialogComponent,
  WmsDialogFooterComponent,
  WmsDialogHeaderComponent,
  WmsIconSelectorComponent,
  WidgetDesignerComponent,
  WmsExpressionErrorDirective
} from "@wms/components";
import { FormFilterBasicComponent } from '../runtime/components/form-filter-basic/form-filter-basic.component';
import { ActionsBasicComponent } from '../runtime/components/actions-basic/actions-basic.component';
import {TabsModule} from "ngx-bootstrap/tabs";
import {LiveWidgetSettingsService, LiveWidgetUtilsService, TypeFactoryService} from "@wms/services";
import {each, extend, find, forEach, isArray, isEmpty, pull, toString, upperCase} from "lodash-es";
import {getClonedObject, getVariableNameFromExpr, isDefined} from "@wm/core";
import {getWidgetRolesArrayFromStr, prepareFieldDefs, resetObjectWithEmptyValues} from "@wms/core";
import {PropertiesTemplateComponent} from "@wms/properties-panel";
import {FormsModule} from "@angular/forms";
import {FilterPipe} from "@wm/components-base";
import {BaseVariableService} from "@wms/variables";
import {PageWsService} from "@wms/workspace";
import {TooltipModule} from "ngx-bootstrap/tooltip";
import {WidgetPropertiesProvider} from "@wms/design-container";

@Component({
  selector: 'wms-live-filter-designer',
  standalone: true,
  imports: [CommonModule,
    WmsDialogFooterComponent,
    WmsDialogBodyComponent,
    WmsDialogHeaderComponent,
    SecurityComponent,
    ActionsBasicComponent,
    TabsModule,
    WmsCriteriaBuilderComponent,
    WmsIconSelectorComponent,
    WmsDialogComponent,
    SearchComponent,
    PropertiesTemplateComponent,
    LiveWidgetsFieldsListComponent,
    FormFilterBasicComponent,
    FormsModule,
    FilterPipe,
    WmsExpressionErrorDirective, TooltipModule],
  templateUrl: './live-filter-designer.component.html',
  styleUrls: ['./live-filter-designer.component.less']
})
export class LiveFilterDesignerComponent extends BaseComponent{

  @Input() propPanelInfo: any;
  @Input() activeWidgetType: any;
  @Output() handleClose = new EventEmitter<any>();
  liveWidgetUtils: LiveWidgetUtilsService;
  liveWidgetSettingsService: LiveWidgetSettingsService;
  toUpperCase = upperCase;
  convertToString = toString;
  everyoneRole: any = ['Everyone'];
  filterButtons: any;
  fieldsKey: any = '';
  filterFieldDef: any;
  variableObj: any;
  fieldsList: any;
  actionSearchKey: string = '';
  myWidgets: any = {};
  private selectedIndex: number | undefined;
  private selectedComponentType: string;

  private dialogDesigner: WidgetDesignerComponent;
  private typeService: TypeFactoryService;
  private variableName: any;
  propertiesConfig: any;
  variableService: BaseVariableService;
  pageWsService: PageWsService;

  constructor(private cdr: ChangeDetectorRef, private widgetPropertiesProvider: WidgetPropertiesProvider) {
    super();
    this.liveWidgetUtils = inject(LiveWidgetUtilsService);
    this.liveWidgetSettingsService = inject(LiveWidgetSettingsService);
    this.dialogDesigner = inject(WidgetDesignerComponent);
    this.typeService = inject(TypeFactoryService);
    this.variableService = inject(BaseVariableService);
    this.pageWsService = inject(PageWsService);
  }

  ngOnInit(): void {
    this.liveWidgetSettingsService.initSettings(this.propPanelInfo, this.activeWidgetType).then(success => {
      this.variableName = getVariableNameFromExpr(this.liveWidgetSettingsService.activeWidgetScope.binddataset);
      this.myWidgets = this.widgetPropertiesProvider.getSubGroup('Mywidgets', 'custom-widgets').widgets;
      this.initLiveFilterDesigner()
    })
  }

  initLiveFilterDesigner() {
    let formFields: any = [];
    let filterVariableExpr: any = [];
    let filterVariable: any = [];
    let defaultButtons: any = this.liveWidgetUtils.getLiveWidgetButtons('LIVEFILTER');
    /*variable bound with the live filter*/
    filterVariableExpr = this.liveWidgetSettingsService.activeWidgetScope.binddataset;
    /*Return if the filter is not bound to any variable*/
    if (!filterVariableExpr) {
      return;
    }
    this.liveWidgetSettingsService.selectedComponent.field = {};
    this.liveWidgetSettingsService.selectedComponent.button = {};
    filterVariableExpr = filterVariableExpr.replace('bind:', '');
    filterVariable = filterVariableExpr.replace('Variables.', ''); // or dataset. At one point there will be just one of these values present
    this.variableName = filterVariable.substring(0, filterVariable.indexOf('.'));
    this.variableObj = this.variableService.variableInstanceCollection[this.pageWsService.activePageName][this.variableName];
    formFields = this.liveWidgetSettingsService.getOrderedFieldsBasedOnMarkUp((pull(this.liveWidgetSettingsService.activeWidgetScope.formFields, undefined)), 'wm-filter-field', 'wm-livefilter');
    this.filterFieldDef = this.getFieldsCopy(formFields);
    /*Adding 'include' attribute to the fields,To decide which fields to be considered while saving designer dialog*/
    each(this.filterFieldDef, (colDef: any) => {
      colDef.dataset = isArray(colDef.dataset) ? undefined : colDef.dataset;
      colDef.widgetTypeOptions = this.liveWidgetSettingsService.fieldTypeWidgetTypeMap[colDef.type];
      if (colDef.type === 'string') {
        colDef.matchmode = colDef.matchmode || (this.variableObj && this.variableObj.matchMode);
      }
      colDef.widget = colDef.widget === 'typeahead' ? 'autocomplete' : colDef.widget;
      if(colDef.displaywidget === 'custom-widget')
        colDef.displaywidget = find(this.myWidgets, (myWidget) => myWidget.defaults.widgetName === colDef.widgetname);
      colDef.filterOn = colDef.dataset ? undefined : colDef.filterOn;
    });
    this.liveWidgetSettingsService.componentDefnObject.button = getClonedObject(this.liveWidgetSettingsService.activeWidgetScope.buttonArray) || [];
    /*Adding 'include' attribute to the buttons,To decide which buttons to be considered while saving designer dialog*/
    each(this.liveWidgetSettingsService.componentDefnObject.button, (butDef) => {
      butDef.include = true;
      butDef.accessroles = butDef.accessroles ? getWidgetRolesArrayFromStr(butDef.accessroles) : this.everyoneRole;
    });
    /*Add the default buttons and set the include to false*/
    defaultButtons.forEach((button: any) => {
      let isButtonExist = this.liveWidgetSettingsService.componentDefnObject.button.some(function (obj: any) {
        return obj.key === button.key;
      });
      if (!isButtonExist) {
        button.accessroles = this.everyoneRole;
        button.include = false;
        this.liveWidgetSettingsService.componentDefnObject.button.push(button);
      }
    });

    let widgetVariable = this.variableService.variableInstanceCollection[this.pageWsService.activePageName][this.variableName];
    this.liveWidgetSettingsService.activeWidgetScope.dataset = widgetVariable?.dataset
    this.liveWidgetSettingsService.activeWidgetScope.propertiesMap = widgetVariable?.propertiesMap


    if (this.liveWidgetSettingsService.activeWidgetScope.binddataset) {
      this.setUpFilter(this.liveWidgetSettingsService.activeWidgetScope.dataset?.data, this.liveWidgetSettingsService.activeWidgetScope.propertiesMap);
    } else {
      // $scope.$on('$destroy', this.liveWidgetSettingsService.activeWidgetScope.filterElement.scope().$watch(filterVariableExpr,  (newVal:any) =>{
      //   if (!newVal || !newVal.data) {
      //     /* set the default initialized fields from filter*/
      //     this.liveWidgetSettingsService.componentDefnObject.field = this.filterFieldDef;
      //     /*select the first column by default*/
      //     this.updateSelectedComponent(this.liveWidgetSettingsService.componentDefnObject.field[0], 'field');
      //   } else {
      //     this.setUpFilter(newVal.data, newVal.propertiesMap);
      //   }
      // }));
    }
  };

  getFieldsCopy(fields: Array<any>) {
    let _fields: Array<any> = [];
    forEach(fields, (field: any) => {
      _fields.push(extend({}, field));
    });
    return _fields;
  }


  updateSelectedComponent(componentDef: any, componentType: any, index?: number, $event?: any) {
    let variable = this.variableObj;
    if (!componentDef) { //if no variable is binded or empty dataset is binded then return back
      return;
    }
    if (index !== this.selectedIndex) {
      let previousSelected = this.liveWidgetSettingsService.selectedComponent[componentType];
      let itemIndex = this.liveWidgetSettingsService.componentDefnObject[componentType].findIndex((comp: any) => comp.key === previousSelected.key);
      if (itemIndex !== -1) {
        this.liveWidgetSettingsService.componentDefnObject[componentType][itemIndex] = previousSelected;
      }
    }
    if (componentDef.isRelated && !componentDef.relatedEntityName) {
      componentDef.isRelated = this.propertiesConfig[componentDef.field].isRelated;
      componentDef.relatedEntityName = this.propertiesConfig[componentDef.field].relatedEntityName;
    }

    if (componentType === 'field') {
      if (componentDef.isRelated === true || componentDef.isRelated === 'true') {
        componentDef.lookupTypeOptions = [];
        componentDef.lookupTypeOptions.push(componentDef.relatedEntityName);
        componentDef.lookupType = componentDef.relatedEntityName;
        if (!isEmpty(this.liveWidgetSettingsService.relatedData)) {
          componentDef.lookupFieldOptions = this.liveWidgetSettingsService.relatedData[componentDef.relatedEntityName]['columns'];
          if (variable.category === "wm.LiveVariable" && variable.operation === "read") {
            this.liveWidgetSettingsService.relatedData[componentDef.relatedEntityName]['criteriaFilterFields'] = this.dialogDesigner.getCriteriaFilterFields(this.dialogDesigner.getTypeForTheEntity(variable, componentDef.relatedEntityName));
          }
          componentDef.lookupField = componentDef?.fieldDefConfig?.lookupField || this.liveWidgetSettingsService.relatedData[componentDef.relatedEntityName]['primaryKey'];
        }
      }
      componentDef.ngClasses = this.liveWidgetUtils.parseNgClasses(componentDef.ngclass);
      this.liveWidgetSettingsService.setDragHandle($event);
    }
    this.liveWidgetSettingsService.selectedComponent[componentType] = {};
    this.liveWidgetSettingsService.selectedComponent[componentType] = componentDef;
    this.liveWidgetSettingsService.focusSelectedComponent();
    this.selectedIndex = isDefined(index) ? index : undefined;
    this.selectedComponentType = componentType;
    if (componentType === 'field') {
      this.liveWidgetSettingsService.widgetTypeOptionsSubject.next();
      this.liveWidgetSettingsService.getOtherWdgtTypes(componentDef.widgetTypeOptions);
      this.liveWidgetSettingsService.onLookupChange(componentDef);
    }
  };


  setUpFilter(data: any, propertiesMap: any) {
    /*this call back function receives the data from the variable*/
    let properties: any = [];
    let filterFieldDefObj: any = {};
    let propertiesMapColumns: any = [];
    /*loop through each columnDef for defaultValues in the property form*/
    each(this.filterFieldDef, function (colDef) {
      filterFieldDefObj[colDef.field || colDef.key] = colDef;
    });
    /*if the data is type json object, make it an array of the object*/
    if (!isArray(data)) {
      data = [data];
    }
    /* if properties map is existed then fetch the column configuration for all nested levels using util function */
    if (propertiesMap) {
      propertiesMapColumns = this.liveWidgetUtils.fetchPropertiesMapColumns(propertiesMap, this.liveWidgetSettingsService.activeWidgetScope.binddataset);
      this.propertiesConfig = propertiesMapColumns.columns;
      this.liveWidgetSettingsService.relatedData = propertiesMapColumns.relatedData;
      properties = [resetObjectWithEmptyValues(this.propertiesConfig)];
    } else {
      properties = data;
    }
    this.liveWidgetSettingsService.componentDefnObject.field = prepareFieldDefs(properties);
    /*loop over the full field definition to prepare final field definitions object*/
    this.liveWidgetSettingsService.filterFields = [];
    this.fieldsList = this.liveWidgetSettingsService.getFieldsList();
    this.liveWidgetSettingsService.fieldsList = this.liveWidgetSettingsService.getFieldsList();

    each(this.liveWidgetSettingsService.componentDefnObject.field, (colDef) => {
      colDef.key = colDef.field
      this.liveWidgetSettingsService.filterFields.push(colDef.field);
      if (this.propertiesConfig[colDef.field].isRelated) {
        colDef.isRelated = this.propertiesConfig[colDef.field].isRelated;
        colDef.relatedEntityName = this.propertiesConfig[colDef.field].relatedEntityName;
      }
      if (!filterFieldDefObj[colDef.field]) {
        colDef.widget = 'text';
        colDef.isRange = false;
        colDef.lookupType = '';
        colDef.lookupField = '';
        colDef.show = true;
        colDef.filterOn = '';

        if (propertiesMap) {
          colDef.type = this.propertiesConfig[colDef.field].type;
          colDef.isPrimaryKey = this.propertiesConfig[colDef.field].isPrimaryKey;
          colDef.generator = this.propertiesConfig[colDef.field].generator;
          colDef.widget = this.liveWidgetSettingsService.fieldTypeWidgetTypeMap[colDef.type][0];
        }
        colDef.widgetTypeOptions = this.liveWidgetSettingsService.fieldTypeWidgetTypeMap[colDef.type];
        colDef.matchmode = this.variableObj && this.variableObj.matchMode;
        this.filterFieldDef.push(colDef);
      }
    });

    /*prepare final list of field definitions for the designer*/
    this.liveWidgetSettingsService.componentDefnObject.field = this.filterFieldDef || this.liveWidgetSettingsService.componentDefnObject.field;
    /*check if select all should be selected*/
    this.liveWidgetSettingsService.updateSelectAll('field', 'pcDisplay');
    this.liveWidgetSettingsService.updateSelectAll('field', 'mobileDisplay');
    this.liveWidgetSettingsService.updateSelectAll('button', 'include');
    /*select the first column by default*/
    if (this.liveWidgetSettingsService.componentDefnObject.field.length && isEmpty(this.liveWidgetSettingsService.selectedComponent.field)) {
      this.updateSelectedComponent(this.liveWidgetSettingsService.componentDefnObject.field[0], 'field');
    }
    if (this.liveWidgetSettingsService.componentDefnObject.button.length && isEmpty(this.liveWidgetSettingsService.selectedComponent.button)) {
      this.updateSelectedComponent(this.liveWidgetSettingsService.componentDefnObject.button[0], 'button');
    }


  };

  assignSelectedComponentInfo() {
    if (this.selectedComponentType) {
      let previousSelected = this.liveWidgetSettingsService.selectedComponent[this.selectedComponentType];
      let index = this.liveWidgetSettingsService.componentDefnObject[this.selectedComponentType].findIndex((comp: any) => comp.key === previousSelected.key);
      if (index !== -1) {
        this.liveWidgetSettingsService.componentDefnObject[this.selectedComponentType][index] = previousSelected;
      }
    }
  }


  showPropertyInSubGroup = (property: any) => {
    return this.liveWidgetSettingsService.activeWidgetScope?.widgetProps[property]?.showindesigner;
  }

  searchFields($event: any) {
    this.fieldsKey = $event.searchKey;
  }

  searchActions = (event: any) => {
    this.actionSearchKey = event.searchKey;
  }

  addCustomComponent = (componentType: any, updateMode?: boolean) => {
    let customKey: any = this.liveWidgetUtils.getCustomFieldKey(this.liveWidgetSettingsService.componentDefnObject[componentType], 'key', 'custom');
    if (componentType === 'field') {
      this.liveWidgetSettingsService.componentDefnObject[componentType] = [...this.liveWidgetSettingsService.componentDefnObject[componentType], {
        'key': customKey,
        'field': customKey,
        'displayname': 'Custom ' + componentType,
        'show': true,
        'pcDisplay': true,
        'mobileDisplay': true,
        'tabletDisplay': true,
        'type': 'string',
        'widgetTypeOptions': this.liveWidgetSettingsService.fieldTypeWidgetTypeMap.custom,
        'allowBinding': true,
        'accessroles': this.everyoneRole
      }];
      this.liveWidgetSettingsService.updateSelectAll('field', 'pcDisplay');
      this.liveWidgetSettingsService.updateSelectAll('field', 'mobileDisplay');
      this.liveWidgetSettingsService.updateSelectAll('field', 'tabletDisplay');
    } else {
      this.liveWidgetSettingsService.componentDefnObject[componentType] = [...this.liveWidgetSettingsService.componentDefnObject[componentType], {
        'key': customKey,
        'displayName': 'Custom ' + componentType,
        'include': true,
        'show': 'true',
        'type': 'button',
        'updateMode': this.activeWidgetType === 'wm-form' ? true : updateMode,
        'shortcutkey': '',
        'class': 'btn-secondary',
        'position': 'footer',
        'widgetType': 'button',
        'accessroles': this.everyoneRole,
      }];
      this.liveWidgetSettingsService.updateSelectAll('button', 'include');
    }
    this.updateSelectedComponent(this.liveWidgetSettingsService.componentDefnObject[componentType][this.liveWidgetSettingsService.componentDefnObject[componentType].length - 1], componentType);
  };

}
